<template>
  <div
    class="rounded-t mb-0 px-4 py-3 border-0 border-b-4 border-solid"
    :class="
      getRegion === 'au'
        ? 'border-green-200 bg-green-100'
        : getRegion === 'nz'
        ? 'border-gray-400 bg-gray-200'
        : 'border-blue-300 bg-blue-200'
    "
  >
    <div class="text-center flex justify-between items-center">
      <div class="rounded-t mb-0 px-4 py-3 border-0">
        <div class="text-center flex justify-between items-center">
          <h3 class="font-semibold text-lg" :class="'text-blueGray-700'">
            {{ title.replaceAll("_", " ").toUpperCase() }}
          </h3>
        </div>
      </div>
      <div class="flex items-center">
        <input
          v-model="searchValue"
          type="text"
          placeholder="Search here"
          class="block w-40 py-2 px-3 mr-2 bg-white text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
        />
        <button
          @click="handleRedirect"
          class="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
        >
          create
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";

export default {
  name: "InstanceTableHeader",
  props: {
    title: {
      type: String,
      required: true
    },
    componentId: {
      type: String,
      required: true
    }
  },
  computed: {
    searchValue: {
      get: function () {
        return this.getSearchValue;
      },
      set: function (val) {
        this.$store.dispatch(Actions.SEARCH_INSTANCE, val);
        this.$store.dispatch(Actions.INSTANCE_SET_PAGE, 0);
      }
    },
    ...mapGetters(["getSearchValue", "getRegion"])
  },
  methods: {
    handleRedirect() {
      this.$store.dispatch(Actions.CHANGE_OPERATION_MODE, {
        operation: "create"
      });
      this.$router.push({
        path: `/component/create/${this.componentId}`
      });
    }
  }
};
</script>
